import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en-US.json';
import ua from './locales/uk-UA.json';
import ru from './locales/ru-RU.json';

export const locales = ['en', 'ua', 'ru'];
export const defaultLocale = 'en';
export const localeLabels = {
  en: 'English',
  ua: 'Українська',
  ru: 'Русский',
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      ua: {
        translation: ua,
      },
      ru: {
        translation: ru,
      },
    },
    lng: localStorage.getItem('lng') || defaultLocale,
    fallbackLng: defaultLocale,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
